import { Selection } from "./index";
import matcher from "../matcher";
export default function (match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/filter.js
// module id = 474
// module chunks = 0